<div class="custom-select-container" data-testid="nav-sidebar-owner-selector">
    <button class="select-trigger" id="owner-selector" (click)="toggleDropdown()" [attr.aria-expanded]="isOpen" [disabled]="samlService.loadingNewOwner()" data-testid="nav-sidebar-owner-selector-trigger-button">
        @if (!samlService.loadingNewOwner()) {
            <span class="selected-label">{{ selectedOption?.name }}</span>
            <img src="assets/icons/arrow-down-blue.svg" alt="chevron" class="chevron" [class.rotated]="isOpen" />
        } @else {
            <app-loading-indicator size="tiny" color="secondary" />
        }
    </button>

    @if (isOpen) {
        <div class="options-panel">
            <ul>
                @for (option of samlService.samlMembershipOwners(); track option.uid) {
                    <li class="option" (click)="selectOption(option)" [class.selected]="option.uid === samlService.chosenUid()" [attr.data-testid]="'nav-sidebar-owner-selector-option-' + option.uid">
                        <p>{{ option.name }}</p>

                        @if (option.uid === samlService.chosenUid()) {
                            <img class="checkmark" src="assets/icons/check-circle.svg" alt="check mark" />
                        }
                    </li>
                }
            </ul>
        </div>
    }
</div>
